import { Box, Button, Card, CardContent, Container, Grid, Stack, Typography } from "@mui/material";
import DesignServicesRoundedIcon from "@mui/icons-material/DesignServicesRounded";
import EngineeringRoundedIcon from "@mui/icons-material/EngineeringRounded";
import HandymanRoundedIcon from "@mui/icons-material/HandymanRounded";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
export default function Leistungen() {
  const { t } = useTranslation();

  const services = t("servicesPage.items", { returnObjects: true }) as { title: string; description: string; slug: string }[];

  const serviceIcons = [
    <DesignServicesRoundedIcon color="secondary" sx={{ fontSize: 48 }} />,
    <EngineeringRoundedIcon color="secondary" sx={{ fontSize: 48 }} />,
    <HandymanRoundedIcon color="secondary" sx={{ fontSize: 48 }} />,
    <AccountBalanceRoundedIcon color="secondary" sx={{ fontSize: 48 }} />,
  ];

  return (
    <Container sx={{ py: { xs: 4, md: 8 } }}>
      {/* Hero Section */}
      <Box sx={{ mb: { xs: 6, md: 10 }, textAlign: "center", maxWidth: 800, mx: "auto" }}>
        <Typography variant="h1" sx={{ mb: 2 }}>
          {t("servicesPage.hero.title")}
        </Typography>
        <Typography variant="h4" color="text.secondary" fontWeight={500}>
          {t("servicesPage.hero.subtitle")}
        </Typography>
      </Box>

      {/* Services Grid */}
      <Grid container spacing={4} sx={{ mb: 8 }}>
        {services.map((service, index) => (
          <Grid item xs={12} md={6} key={index}>
            <Card
              elevation={0}
              sx={{
                height: "100%",
                border: "1px solid var(--border)",
                backgroundColor: "var(--surface)",
                transition: "transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 12px 24px rgba(0,0,0,0.05)",
                },
              }}
            >
              <CardContent sx={{ p: { xs: 3, md: 5 } }}>
                <Stack spacing={3}>
                  <Box
                    sx={{
                      width: 80,
                      height: 80,
                      borderRadius: "50%",
                      backgroundColor: "primary.main",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {serviceIcons[index]}
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="h3" sx={{ mb: 2 }}>
                      {service.title}
                    </Typography>
                    <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.6, fontSize: "1.05rem", mb: 4 }}>
                      {service.description}
                    </Typography>
                  </Box>
                  <Button
                    component={RouterLink}
                    to={`/leistungen/${service.slug}`}
                    variant="outlined"
                    color="primary"
                    sx={{ alignSelf: "flex-start", mt: "auto" }}
                  >
                    Mehr erfahren &rarr;
                  </Button>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* CTA Section */}
      <Box sx={{ textAlign: "center", mt: 10, p: 6, backgroundColor: "var(--surface)", borderRadius: 4 }}>
        <Typography variant="h3" sx={{ mb: 3 }}>
          {t("servicesPage.cta.title")}
        </Typography>
        <Button component={RouterLink} to="/angebot" variant="contained" color="primary" size="large" sx={{ px: 6, py: 1.5 }}>
          {t("servicesPage.cta.button")}
        </Button>
      </Box>
    </Container>
  );
}
